import * as React from "react";
import { observer } from "mobx-react";
import { FlightFareTableProps } from "components/flexComponents/Flights/typings";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "./l10";
import { UitkText } from "@egds/react-core/text";

export const FlightFareTable: React.FC<FlightFareTableProps> = observer(({ flights }) => {
  if (flights == null || flights.length === 0) {
    return null;
  }
  const { formatText } = useLocalization();

  return (
    <main>
      <table className="uitk-table internal-border">
        <thead className="uitk-table-head">
          <tr>
            <th scope="col">{formatText(locKeys.flightFareTableOrigin)}</th>
            <th scope="col">{formatText(locKeys.flightFareTableDestination)}</th>
            <th scope="col">{formatText(locKeys.flightFareTableTravelDates)}</th>
            <th scope="col">{formatText(locKeys.flightFareTableFlightsFrom)}</th>
          </tr>
        </thead>
        <tbody className="uitk-table-body">
          {flights.map((flight, flightIndex) => (
            <tr key={flightIndex}>
              <td>{flight.origin.code}</td>
              <td>
                <a href={flight.searchUrl}>{flight.destination.parent.name}</a>
              </td>
              <td>
                <span aria-hidden="true">
                  {flight.mediumFormattedDepartureDate} - {flight.mediumFormattedArrivalDate}
                </span>
                <span className="is-visually-hidden">
                  {formatText(
                    locKeys.flightAccessibilityTravelDates,
                    flight.a11yFormattedDepartureDate,
                    flight.a11yFormattedArrivalDate
                  )}
                </span>
              </td>
              <td>
                <a href={flight.searchUrl}>{flight.priceModel.formattedPrice}</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <UitkText inline="small">{formatText(locKeys.flightFareTableDisclaimer)}</UitkText>
    </main>
  );
});
